'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@enlighten/design-system/dist/Box';
import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import Image from 'next/image';
import * as ArrowRightIconComponent from '../../assets/images/fs-roof/arrow-right-icon.svg';
import Image1Mobile from '../../assets/images/fs-roof/img-1-mobile.png';
import Image1Pc from '../../assets/images/fs-roof/img-1-pc.png';
const ArrowRightIcon = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? ArrowRightIconComponent.default
    : ArrowRightIconComponent.ReactComponent;
const imgAlt = `
태양광 사업자 5명 중 1명이 선택한 발전왕

0원 지붕태양광
투자비 0원 / 담보 필요없음 / 수익 2.7억*
* 지붕 약 300평, 99kW 발전소 기준
`;
export default function FsRoofSection1({ onClick }) {
    return (_jsxs(Grid, { position: "relative", container: true, justifyContent: "center", alignItems: "center", width: "100%", height: { xs: 'auto', md: 860 }, sx: {
            background: { md: 'linear-gradient(180deg, #2452EE, #103BCE)' },
        }, children: [_jsx(Box, { display: { xs: 'none', md: 'block' }, sx: {
                    '& img': {
                        width: 'auto',
                        height: 860,
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: Image1Pc, alt: imgAlt })) : (_jsx("img", { src: Image1Pc, alt: imgAlt })) }), _jsx(Box, { display: { xs: 'block', md: 'none' }, width: "100%", sx: {
                    '& img': {
                        width: '100%',
                        height: 'auto',
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { src: Image1Mobile, alt: imgAlt })) : (_jsx("img", { src: Image1Mobile, alt: imgAlt })) }), _jsx(Box, { position: "absolute", bottom: { xs: '30%', md: 240 }, display: "flex", justifyContent: "center", width: { xs: '70%', md: 'auto' }, height: { xs: 'auto', md: 52 }, zIndex: 99, sx: {
                    '& img': {
                        width: { xs: '100%', md: 'auto' },
                        height: { xs: 'auto', md: 52 },
                    },
                }, children: _jsxs(Button, { variant: "contained", onClick: onClick, sx: {
                        bgcolor: '#041446',
                        fontSize: { xs: 'calc(min(100vw, 512px) * 0.05)', md: 16 },
                        width: { xs: '100%', md: 253 },
                        height: { xs: 'auto', md: 52 },
                        aspectRatio: '253 / 52',
                        borderRadius: 1,
                        ':hover': {
                            bgcolor: '#293F7E',
                        },
                    }, children: ["\uBB38\uC758\uD558\uAE30", _jsx(ArrowRightIcon, {})] }) }), _jsx(Grid, { display: { xs: 'none', md: 'flex' }, position: "absolute", bottom: 0, container: true, height: 258, sx: {
                    background: 'linear-gradient(180deg, rgba(35, 81, 237, 0.00) 0%, #0C37C9 100%)',
                } })] }));
}
